
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M9.06 32.21H2.59M7.77 25.38H0M9.06 18.56H2.59M25.12 6.81v4.5M28.34 6.38a2.25 2.25 0 100-4.5h-6.43a2.27 2.27 0 00-2.29 2.25 2.27 2.27 0 002.29 2.25z"}}),_c('circle',{attrs:{"cx":"25.12","cy":"24.61","r":"13.51","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M25.12 17.1v7.51L30.26 20M15.14 11.1l1.96 2.77M35.1 11.1l-1.96 2.77"}})])
          )
        }
      }
    